import { render, staticRenderFns } from "./PatientList.vue?vue&type=template&id=25ff29e2&scoped=true&"
import script from "./PatientList.vue?vue&type=script&lang=ts&"
export * from "./PatientList.vue?vue&type=script&lang=ts&"
import style0 from "./PatientList.vue?vue&type=style&index=0&id=25ff29e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ff29e2",
  null
  
)

export default component.exports